// src/components/GuestEditModal.jsx
import { useState } from "react";

function GuestEditModal({ isOpen, onClose, currentGuests, onSave }) {
  const [newGuests, setNewGuests] = useState(currentGuests);

  const increaseGuests = () => setNewGuests((prev) => prev + 1);
  const decreaseGuests = () =>
    setNewGuests((prev) => (prev > 1 ? prev - 1 : 1));
  const handleSave = () => {
    if (newGuests < 1) {
      alert("Guests cannot be less than 1");
      return;
    }
    onSave(newGuests);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop all_modalss">
      <div className="modal-container">
        <h3>Edit Guests</h3>

        <div className="main_area_sect">
          <div className="us_cntens">
            <p>Adults</p>
            <span>Age 13+</span>
          </div>
          <div className="biths_adses">
            <span className="addsss" onClick={decreaseGuests}>
              -
            </span>
            {/* <input type="text" min="1" value={newGuests} onChange={(e) => setNewGuests(Number(e.target.value))} className="form-control" /> */}
            <input
              type="text"
              value={newGuests}
              readOnly
              className="form-control"
            />
            <span className="addsss" onClick={increaseGuests}>
              +
            </span>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>

      {/* Simple Modal Styling */}
      <style jsx>{`
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .modal-container {
          background: white;
          padding: 20px;
          width: 350px;
          border-radius: 10px;
          text-align: center;
        }
        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
        }
        .btn {
          padding: 8px 15px;
          border-radius: 5px;
          cursor: pointer;
        }
        .btn-primary {
          background: #007bff;
          color: white;
        }
        .btn-secondary {
          background: #ccc;
          color: black;
        }
      `}</style>
    </div>
  );
}

export default GuestEditModal;
